import { render, staticRenderFns } from "./Mouth.vue?vue&type=template&id=6d4a9e58&scoped=true&"
import script from "./Mouth.vue?vue&type=script&lang=js&"
export * from "./Mouth.vue?vue&type=script&lang=js&"
import style0 from "./Mouth.vue?vue&type=style&index=0&id=6d4a9e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a9e58",
  null
  
)

export default component.exports